module.exports = __webpack_public_path__ + "img/hero.c35f24e1.png";